import { TextInput, useDataProvider, useInput } from 'react-admin';
import { useEffect, useState } from 'react';

const ReleaseNum = (props) => {
    const dataProvider = useDataProvider();
    const { field } = useInput(props);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!loaded) {
            dataProvider.getOne('releasenums', { id: 0 })
                .then(({ data }) => {
                    if (data?.Release_Num && !field.value) {
                        field.onChange(data.Release_Num);
                        setLoaded(true);
                    }
                })
                .catch(error => {
                    console.error('Error fetching release number:', error);
                });
        }
    }, [dataProvider, field, loaded]);

    return <TextInput {...props} />;
};

export default ReleaseNum;
